import { officialAccounts } from '@/mocks/siteData';
import SectionHeading from '@/components/base/SectionHeading';

const responsePromises = [
  { icon: 'ri-time-line', title: '24 小时', desc: '线索邮箱完成首次查看' },
  { icon: 'ri-chat-check-line', title: '72 小时', desc: '给出是否进入核查流程的判断' },
  { icon: 'ri-calendar-check-line', title: '2 个工作日', desc: '商务合作事项首次回复' },
];

export default function VerifySection() {
  return (
    <section className="bg-background-50 py-14 md:py-24">
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-7">
            <SectionHeading
              kicker="Verify First"
              title="如何确认你联系到的是官方"
              description="防范冒名是保护信源安全的一部分。收到任何自称深瞳爆料的联络时，请按下面的顺序核对一遍。"
            />

            <ol className="mt-8 space-y-5">
              <li className="flex items-start gap-4">
                <span className="shrink-0 w-9 h-9 flex items-center justify-center rounded-md bg-foreground-950 font-mono text-xs text-background-50">
                  01
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    核对邮箱域名
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                    所有官方邮箱都使用 shentong-baoliao.com 域名。出现拼写相近的其他域名时，
                    请不要回复、不要点击其中链接。
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="shrink-0 w-9 h-9 flex items-center justify-center rounded-md bg-foreground-950 font-mono text-xs text-background-50">
                  02
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    对照官方账号清单
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                    平台仅在下方列出的账号发布内容。未列出的账号、社群与个人号均不代表平台立场。
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <span className="shrink-0 w-9 h-9 flex items-center justify-center rounded-md bg-foreground-950 font-mono text-xs text-background-50">
                  03
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    通过咨询邮箱二次确认
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                    对任何联络存疑时，写一封邮件到 contact@shentong-baoliao.com 说明情况，
                    我们会回复确认是否为平台行为。
                  </p>
                </div>
              </li>
            </ol>

            <div className="mt-8 flex flex-wrap gap-2.5">
              {officialAccounts.map((account) => (
                <span
                  key={account.name}
                  className="inline-flex items-center gap-2 bg-secondary-100 text-secondary-900 border border-secondary-200 rounded-full pl-2 pr-3.5 py-1.5 text-xs"
                >
                  <i className={`${account.icon} text-sm`}></i>
                  {account.handle}
                </span>
              ))}
            </div>

            <p className="mt-7 flex items-start gap-3 text-xs md:text-sm leading-relaxed bg-primary-100 text-primary-900 border border-primary-200 rounded-md px-4 py-3.5">
              <i className="ri-error-warning-line text-lg shrink-0 mt-0.5"></i>
              <span>
                平台不会索要短信验证码、银行卡信息，也不会以“加急曝光”“付费置顶”为由收取费用。
                遇到此类要求请立即停止沟通并告知我们。
              </span>
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-secondary-950 text-background-100 rounded-lg p-6 md:p-8 lg:sticky lg:top-28">
              <p className="font-mono text-xs tracking-[0.3em] uppercase text-accent-400">
                Response Promise
              </p>
              <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold text-background-50">
                我们的响应约定
              </h3>
              <ul className="mt-7 space-y-6">
                {responsePromises.map((item) => (
                  <li key={item.title} className="flex items-start gap-4">
                    <span className="shrink-0 w-11 h-11 flex items-center justify-center rounded-md bg-secondary-900 border border-secondary-800 text-accent-400">
                      <i className={`${item.icon} text-lg`}></i>
                    </span>
                    <div>
                      <p className="font-heading text-lg font-bold text-background-50">
                        {item.title}
                      </p>
                      <p className="mt-1 text-sm text-background-300">{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
              <p className="mt-8 pt-6 border-t border-secondary-800 text-xs leading-relaxed text-background-400">
                线索数量较多时响应可能略有延迟，但所有材料都会按保密规范登记处理。加密邮件优先查看。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}